import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import type { FormInputs } from "./form-validation/user-password.schema";
import { schema, defaultValues } from "./form-validation/user-password.schema";
import type { UserPassword } from "../../../../write/domain/types/user";
import { PasswordInput } from "../../../shared/password-input/password-input.content";
import { Form } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { ThemedButton } from "@shared-kernel/primary/shared/themed-button/themed-button";

interface Props {
  title: string;
  onSubmit: (body: UserPassword) => void;
  useFunction: () => void;
  userId: string;
  token: string;
  email: string;
}

export const PasswordForm = ({ title, onSubmit, useFunction, userId, token, email }: Props) => {
  const form = useForm<FormInputs>({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const {
    watch,
    formState: { isDirty },
  } = form;

  const handleOnSubmit = (formBody: FormInputs) => {
    const body = { ...formBody, userId, token };
    onSubmit(body);
  };

  useFunction();

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleOnSubmit)} className="space-y-4">
        <div className="mt-3">
          <span>{title}</span>
          <br />
          <br />
          <span>{email}</span>
        </div>
        <PasswordInput control={form.control} password={watch("password")} />
        <div className="col-span-2 flex justify-end">
          <ThemedButton isDirty={isDirty} label="Enregistrer"></ThemedButton>
        </div>
      </form>
    </Form>
  );
};
